// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__BEdSz","col":"CardReaderDesc_col__2nkNe","label":"CardReaderDesc_label__wuibw"};